export enum UserType {
	None = 'None',
	Admin = 'Admin',
	Member = 'Member',
}

export interface UserContextState {
	clientId: string,
	loggedIn: boolean,
	context: UserType,
}

export enum UserContextActionTypes {
	UPDATE_USER_CONTEXT = 'UPDATE_USER_CONTEXT',
}
